import { Activity } from '@user/features/Activity/typings'
import { get, isAPIError } from '@user/store/services/crud'
import { toast } from '@sales-center/components'
import { getActivityUrl } from '../constants'

export async function fetchActivity(id: number): Promise<Activity | undefined> {
  const response = await get(`${getActivityUrl}/${id}`)

  if (!response.ok) {
    // The API error envelope is flat — { StatusCode, Message } straight from
    // ExceptionMiddleware — so there is no `payload` to read (reading one made
    // isAPIError(undefined) throw, so every failed load rejected before the
    // toast). The body can also be non-JSON or a plain transport-failure string;
    // neither may throw, both fall back to the generic message.
    const error = await response.json().catch(() => undefined)
    toast.error(
      error != null && isAPIError(error)
        ? error.Message
        : 'Failed to load Activity',
    )
    return undefined
  }

  return response.json()
}
